import React, { useEffect } from "react";
import AuthLayout from "../AuthLayout/AuthLayout";
import { Button, message } from "antd";
import * as Yup from "yup";
import { ErrorMessage, Field, Formik, Form as FormikForm } from "formik";
import InputField from "../../components/Input/Inputfeild";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { requestPasswordResetOtp } from "../../api/orgRegistry";
import {
  savePasswordResetSession,
  clearPasswordResetSession,
  otpExpiryFromNow,
} from "../../utils/passwordResetSession";
import "./ForgetPassword.css";

const ForgetPassword = () => {
  const initialValues = {
    email: "",
  };

  const history = useHistory();

  /* This screen is the start of the flow, however it was reached - a fresh visit, Back
     from a later step, or a restart after a failed reset. Any half-finished attempt is
     dropped here so a stale request id can never be carried into a new one. */
  useEffect(() => {
    clearPasswordResetSession();
  }, []);

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email format")
      .matches(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/, "Please enter a valid email address")
      .required("Email Address is required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    const email = values.email.trim();

    try {
      const otpRequestId = await requestPasswordResetOtp(email);
      const otpExpiresAt = otpExpiryFromNow();

      // The OTP request id is needed by the verify call on the next page. Router
      // state covers the normal navigation; the session store keeps the flow (and
      // the countdown) alive if the user refreshes the OTP page.
      savePasswordResetSession({ email, otpRequestId, otpExpiresAt, otpVerified: false });

      message.success("We've sent a verification code to your email.");
      history.push("/otp-verify", { email, otpRequestId, otpExpiresAt });
    } catch (error) {
      console.error("Password reset OTP request failed:", error);
      message.error(error.message || "We couldn't send the verification code. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <AuthLayout>
      <div className="signin-container">
        <div className="signin-header">
          <h1>Forgot Password</h1>
          <p>Enter the email address associated with your account and we will send you a code to reset your password</p>
        </div>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          validateOnBlur={false}
        >
          {({ isSubmitting, errors, touched }) => (
            <FormikForm className="login-form">
              <div className="input-wrapper">
                <p>Email Address</p>
                <Field name="email">
                  {({ field }) => (
                    <InputField
                      {...field}
                      placeholder="Email Address"
                      className={`custom-input ${errors.email && touched.email ? "input-error" : ""}`}
                    />
                  )}
                </Field>
                <ErrorMessage name="email" component="div" className="error-message" />
              </div>

              <div className="back-to-signin-container">
                <label className="back-to-signin forget-password " onClick={() => history.push("/login")}>
                  Back to Sign In
                </label>
              </div>

              <Button htmlType="submit" type="primary" className="signin-btn" disabled={isSubmitting}>
                {isSubmitting ? "Sending..." : "Send Verification Code"}
              </Button>
            </FormikForm>
          )}
        </Formik>
      </div>
    </AuthLayout>
  );
};

export default ForgetPassword;
